import { Box, TextField, Button, Slider, Typography } from "@mui/material";
import { useState } from "react";
import InputMask from "react-input-mask";
import emailjs from "@emailjs/browser";

const FormComponent = () => {
  const [formData, setFormData] = useState({
    cpf: "",
    cep: "",
    telefone: "",
    email: "",
    valor: 1000,
  });

  const [errors, setErrors] = useState({
    cpf: false,
    cep: false,
    telefone: false,
    email: false,
  });

  const validateCPF = (cpf) => /^\d{3}\.\d{3}\.\d{3}-\d{2}$/.test(cpf);
  const validateCEP = (cep) => /^\d{5}-\d{3}$/.test(cep);
  const validateTelefone = (telefone) => /^\(\d{2}\) \d{4,5}-\d{4}$/.test(telefone);
  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    let isValid = true;
    if (name === "cpf") isValid = validateCPF(value);
    if (name === "cep") isValid = validateCEP(value);
    if (name === "telefone") isValid = validateTelefone(value);
    if (name === "email") isValid = validateEmail(value);
    setErrors({ ...errors, [name]: !isValid });
  };

  const handleSliderChange = (event, newValue) => {
    setFormData({ ...formData, valor: newValue });
  };

  const sendEmail = () => {
    const templateParams = {
      cpf: formData.cpf,
      cep: formData.cep,
      telefone: formData.telefone,
      email: formData.email,
      valor: formData.valor,
    };

    emailjs
    .send('service_zky97ij', 'template_gqlncp5', templateParams, 'K6sXHa7DR1iJvD8GU')
      .then((response) => {
        alert("Email enviado com sucesso!");
      })
      .catch((error) => {
        alert("Erro ao enviar email. Tente novamente.");
      });
  };

  const isFormValid =
    Object.values(formData).every((value) => value !== "") &&
    !Object.values(errors).includes(true);

  return (
    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, mt: 2 }}>
      <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap", justifyContent: "center" }}>
        {Object.keys(formData).map((field) => (
          <Box key={field} sx={{ p: 2, borderRadius: 2, backgroundColor: "white", width: "250px" }}>
            <Typography variant="subtitle1">{field.toUpperCase()}</Typography>
            {field === "cpf" || field === "cep" || field === "telefone" ? (
              <InputMask
                mask={field === "cpf" ? "999.999.999-99" : field === "cep" ? "99999-999" : "(99) 99999-9999"}
                value={formData[field]}
                onChange={handleChange}
              >
                {() => (
                  <TextField
                    name={field}
                    variant="standard"
                    fullWidth
                    error={errors[field]}
                    helperText={errors[field] ? `Formato inválido para ${field}` : ""}
                  />
                )}
              </InputMask>
            ) : (
              <TextField
                name={field}
                variant="standard"
                value={formData[field]}
                onChange={handleChange}
                fullWidth
                error={errors[field]}
                helperText={errors[field] ? `Formato inválido para ${field}` : ""}
              />
            )}
          </Box>
        ))}
      </Box>

      <Box sx={{ width: 300, textAlign: "center" }}>
        <Typography gutterBottom>Valor: R$ {formData.valor.toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</Typography>
        <Slider
          value={formData.valor}
          onChange={handleSliderChange}
          min={50000}
          max={1000000}
          step={10}
          valueLabelDisplay="auto"
          marks={[{ value: 50000, label: "R$50.000" }, { value: 1000000, label: "R$1.000.000" }]}
        />
      </Box>

      <Button variant="contained" color="primary" disabled={!isFormValid} onClick={sendEmail}>
        Enviar Dados
      </Button>
    </Box>
  );
};

export default FormComponent;
